import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IFiltersLamenessTable } from 'models'

export const defaultInitialState: IFiltersLamenessTable = {
	tags: [],
	lameness: {
		statuses: [],
		startOf: '',
		endOf: '',
	},
	treatmentStatus: {
		statuses: [],
		startOf: '',
		endOf: '',
	},
	inspectionStatus: {
		statuses: [],
		startOf: null,
		endOf: null,
	},
	diagnoses: {
		ids: [],
	},
	cowAge: {
		startOf: '',
		endOf: '',
	},
	groups: {
		ids: [],
	},
	lactation: {
		statuses: [],
		startOf: '',
		endOf: '',
	},
	fatness: {
		startOf: '',
		endOf: '',
	},
	examiners: {
		ids: [],
	},
	lastTrim: {
		startOf: '',
		endOf: '',
	},
	lastMilking: {
		startOf: '',
		endOf: '',
	},
	lastLamenessMeasurement: {
		startOf: '',
		endOf: '',
	},
	responsiblePersons: {
		ids: [],
	},
	isLateTrims: false,
	dateRange: {
		startDate: null,
		endDate: null,
	},
}

interface ILamenessFilterState {
	lamenessFilters: IFiltersLamenessTable
	trimFilters: IFiltersLamenessTable
}

const initialState: ILamenessFilterState = {
	lamenessFilters: defaultInitialState,
	trimFilters: defaultInitialState,
}

const lamenessFilterSlice = createSlice({
	name: 'lamenessFilter',
	initialState,
	reducers: {
		setLamenessFilters: (
			state,
			action: PayloadAction<IFiltersLamenessTable>,
		) => {
			state.lamenessFilters = action.payload
		},
		setTrimFilters: (state, action: PayloadAction<IFiltersLamenessTable>) => {
			state.trimFilters = action.payload
		},
	},
})

export const { setLamenessFilters, setTrimFilters } =
	lamenessFilterSlice.actions
export default lamenessFilterSlice.reducer
